import { useEffect, useState } from 'react';
import { listQueuedForMe, type QueuedForMeRow } from '../api/campaigns';

// Small banner shown on the Sprint home so newly-pushed campaigns are visible
// without switching tabs. Per brief §15: "Queued for me inbox on home screen."

export function QueuedForMeBanner() {
  const [rows, setRows] = useState<QueuedForMeRow[]>([]);

  useEffect(() => {
    let active = true;
    listQueuedForMe()
      .then((r) => {
        if (active) setRows(r);
      })
      .catch(() => {
        // Silent — the Campaigns tab surfaces real errors.
      });
    return () => {
      active = false;
    };
  }, []);

  if (rows.length === 0) return null;
  const top = rows.slice(0, 3);

  return (
    <section
      role="status"
      className="rounded-lg border border-signal-amber/40 bg-signal-amber/5 px-4 py-3"
    >
      <p className="font-mono text-[0.7rem] uppercase tracking-[0.18em] text-signal-amber">
        Queued for you · {rows.length}
      </p>
      <ul className="mt-1 space-y-0.5 font-sans text-sm text-graphite-900">
        {top.map((row) => (
          <li key={row.campaign_id}>
            {row.campaigns.name}
            {row.campaigns.point_goal ? (
              <span className="ml-2 font-mono text-[0.7rem] text-graphite-500">
                {row.campaigns.point_goal}pt goal
              </span>
            ) : null}
          </li>
        ))}
      </ul>
      {rows.length > top.length ? (
        <p className="mt-1 font-mono text-[0.7rem] text-graphite-500">
          + {rows.length - top.length} more on the Campaigns tab
        </p>
      ) : null}
    </section>
  );
}
